var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 16,
    viewBox: "0 0 51 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_5642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4496 0.299805L11.2496 10.7998L9.54961 1.7998C9.44961 0.999805 8.64961 0.299805 7.74961 0.299805H0.949609L0.849609 0.699805C2.24961 0.999805 3.54961 1.3998 4.74961 1.9998C5.24961 2.2998 5.64961 2.7998 5.74961 3.3998L8.94961 15.7998H13.1496L19.6496 0.299805H15.4496Z",
    fill: "#003383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3498 0.299805L18.0498 15.7998H22.0498L25.3498 0.299805H21.3498Z",
    fill: "#003383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2496 0C29.2496 0 26.5496 2.1 26.4496 5.1C26.4496 7.3 28.4496 8.6 29.9496 9.3C31.5496 10.1 32.0496 10.5 32.0496 11.2C32.0496 12.2 30.8496 12.7 29.6496 12.7C28.2496 12.7 26.8496 12.4 25.5496 11.7L24.8496 15.2C26.2496 15.8 27.7496 16 29.3496 16C33.5496 16 36.3496 13.9 36.3496 10.7C36.3496 6.6 30.7496 6.4 30.7496 4.6C30.7496 4 31.2496 3.5 32.4496 3.3C33.8496 3.2 35.1496 3.4 36.3496 4L37.0496 0.7C35.7496 0.2 34.5496 0 33.2496 0Z",
    fill: "#003383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1498 0.299805H43.7498C43.0498 0.299805 42.3498 0.699805 42.0498 1.3998L36.0498 15.6998H40.2498L41.0498 13.3998H46.1498L46.6498 15.6998H50.3498L47.1498 0.299805ZM42.2498 10.2998L44.3498 4.4998L45.5498 10.2998H42.2498Z",
    fill: "#003383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_5642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5,
    height: 16,
    fill: "white",
    transform: "translate(0.849609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ee62e10efd0cff826612db53e27066e8.svg";
export { ForwardRef as ReactComponent };